
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.657 2.343A7.948 7.948 0 008 0a7.948 7.948 0 00-5.657 2.343A7.948 7.948 0 000 8c0 2.137.832 4.146 2.343 5.657A7.948 7.948 0 008 16a7.948 7.948 0 005.657-2.343A7.948 7.948 0 0016 8a7.948 7.948 0 00-2.343-5.657zM8 7.5c1.24 0 2.25 1.01 2.25 2.25a2.253 2.253 0 01-1.635 2.164.157.157 0 00-.115.15v.422c0 .27-.207.5-.476.513A.5.5 0 017.5 12.5v-.436a.157.157 0 00-.115-.15 2.254 2.254 0 01-1.635-2.15.508.508 0 01.485-.514.5.5 0 01.515.5c0 .719.61 1.298 1.34 1.247a1.255 1.255 0 001.157-1.158C9.297 9.11 8.719 8.5 8 8.5c-1.24 0-2.25-1.01-2.25-2.25 0-1.027.692-1.896 1.635-2.164a.157.157 0 00.115-.15v-.422c0-.27.207-.5.476-.513A.5.5 0 018.5 3.5v.436c0 .07.047.13.115.15a2.254 2.254 0 011.635 2.15.508.508 0 01-.485.514.5.5 0 01-.515-.5c0-.719-.61-1.298-1.34-1.247a1.255 1.255 0 00-1.157 1.158C6.703 6.89 7.281 7.5 8 7.5z","fill":"#6C6C6C"}})])
          )
        }
      }
    